import React from "react";
import Layout from "../../Layout/Layout.jsx";
import Right from './Sections/RightArticle.jsx'
import Left from './Sections/LeftArticle.jsx'
import { MDBCard, MDBCardBody } from "mdbreact";
import Paginations from '../../components/Pagination/Pagination.jsx';
import Loading from "../../components/Loading/Loading.jsx";
import getFileData from "../../APICall/Api.jsx";

class GenericPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      language: window.language.setLanguage(this.props.match.params.lang).components,
      error: null,
      materials: {},
      currentPage: [],
      pages: [],
      pagination: [],
      isLoaded: false,
      url: getFileData
    };
  }

  splitIntoPages = (projects) => {
    let limit = 3;
    return projects.chunk(limit);
  }

  getPagination = (pages, activePage) => {
    var _pagination = pages.map((props, key) => { return (key === activePage) ? { active: true, text: key + 1 } : { text: key + 1 } });
    _pagination.unshift({ text: "PREV" });
    _pagination.push({ text: "NEXT" });
    this.setState({
      pagination: _pagination
    });
  }

  test = (pages, activePage) => {
    var _pagination = pages.map((props, key) => { return (key === activePage) ? { active: true, text: key + 1 } : { text: key + 1 } });
    _pagination.unshift({ text: "PREV" });
    _pagination.push({ text: "NEXT" });
    return _pagination;
  }

  getPaginationObject = (pagi) => {
    return <Paginations
      pages={pagi}
      color="info"
      changePage={this.gotoPage}
    />
  }

  getProjects = (projects) => {
    let _pages = this.splitIntoPages(projects);

    this.getPagination(_pages, 0);

    this.gotoPage(1);
  }

  isArrayItemExists = (array, item) => {
    for (var i = 0; i < array.length; i++) {
      if (JSON.stringify(array[i]) === JSON.stringify(item)) {
        return i;
      }
    }
  }

  gotoPage = (no) => {
    var _index = this.isArrayItemExists(this.state.pages, this.state.currentPage) //this.state.pages.indexOf(this.state.currentPage);
    var _pages = this.state.pages
    if (no === "NEXT" && _pages.length > _index + 1) {
      this.setState({
        currentPage: this.state.pages[_index + 1]
      });
      this.getPagination(this.state.pages, _index + 1);
    }
    else if (no === "PREV" && _index > 0) {
      this.setState({
        currentPage: this.state.pages[_index - 1]
      });
      this.getPagination(this.state.pages, _index - 1);
    }
    else if (Number.isInteger(no)) {
      this.setState({
        currentPage: this.state.pages[parseInt(no, 10) - 1]
      });
      this.getPagination(this.state.pages, parseInt(no, 10) - 1);
    }
  }

  componentWillReceiveProps(newProps) {
    this.callAPI(newProps.match.params.lang.capitalize(), newProps.match.params.component.capitalize())
  }

  componentDidMount() {
    this.callAPI(this.props.match.params.lang.capitalize(), this.props.match.params.component.capitalize(), 0)
  }

  callAPI = (lang, component) => {
    fetch(`${this.state.url.getFileData}/${component}${lang}.json`,
      { method: 'get', headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }) }
    )
      .then(res => res.json())
      .then(
        (result) => {
          var reversedResult = result[this.props.match.params.component].elements.reverse();
          this.setState({
            isLoaded: true,
            materials: result,
            currentPage: this.splitIntoPages(reversedResult)[0],
            pages: this.splitIntoPages(reversedResult),
          });
          this.getPagination(this.state.pages, 0);
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error: error
          });
        }
      )
  }


  render() {
    if (this.state.error) {
      return <div>Error: {this.state.error.message}</div>;
    } else if (!this.state.isLoaded) {
      return <Loading />;
    } else {
      return (
        <Layout
          language={window.language.setLanguage(this.props.match.params.lang).components}
          color="white"
          {...this.props}
        >
          <MDBCard className="my-5 px-5 pb-5 container">
            <MDBCardBody>
              <h2 className="h1-responsive font-weight-bold text-center my-5">
                {this.state.materials.title}
              </h2>
              <p className="text-center w-responsive mx-auto mb-5">
                {this.state.materials.mainTitle}
              </p>
              {this.state.currentPage.map((prop, key) => {
                return (parseInt(key, 10) % 2 === 0) ?
                  <div key={key + 1}><Left {...prop} key={prop.title + key + 1} /><hr className="my-5" /></div> :
                  <div key={key + 1}><Right {...prop} key={prop.title + key + 1} /><hr className="my-5" /></div>
              })}

            </MDBCardBody>
            <div className="align-self-center">
              {this.getPaginationObject(this.state.pagination)}
            </div>
          </MDBCard>
        </Layout>
      );
    }
  }
}
export default GenericPage;





// WEBPACK FOOTER //
// ./src/views/GenericPage/GenericPage.jsx